import { SiteFooter } from '@/components/layout/SiteFooter';

/** Site footer — light chrome for all marketing and content pages. */
export default function Footer() {
  return <SiteFooter variant="light" />;
}
